export default class pseudoLink {
    constructor(context) {
        this.context = context;

        this.context.addEventListener('click', this.relocate.bind(this));
    }

    relocate(event) {
        event.preventDefault();

        const elem = event.currentTarget;
        const href = elem.getAttribute('href') || elem.querySelector('a').getAttribute('href');

        document.location.href = href;
    }
}
